import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { User } from 'app/classes/user';
import { APIService } from 'app/shared/api.service';
import { UserService } from 'app/shared/user.service';
import { WindowService } from 'app/shared/window.service';
import { Session } from 'inspector';

import { Subscription } from 'rxjs';
import { IDirtyData } from './org-user-details/org-user-details.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-org-users-home',
  templateUrl: './org-users-home.component.html',
  styleUrls: ['./org-users-home.component.css'],
  providers: [],
  standalone: false
})
export class OrgUsersHomeComponent implements OnInit, OnDestroy {

  user: User;
  session: Session;
  users = signal<User[]>(null);
  userSubscription: Subscription;
  today: Date = new Date();
  tomorrow: Date = new Date();

  dialogRef: any;
  isLoading: boolean;
  is = { admin: false };
  can = { invite: false, admin: false };
  toolar = [];
  userSelected = signal<User>(null);
  isEditingUser = signal<boolean>(false);
  dirtyData: IDirtyData;

  wantsToDeleteUser = false;
  showAdmin = false;

  constructor(private windowService: WindowService, private apiService: APIService, private userService: UserService, private route: Router) {

  }

  ngOnInit(): void {
    this.is.admin = this.can.invite = this.apiService.isAdmin();
    // Show admins in the 4D module and only to other admins
    this.showAdmin = this.apiService.isAdmin() && this.apiService.getUserOrg().id === 4;

    if (!this.can.invite) {
      this.can.invite = this.apiService.hasOrgRole('invite_user');
    }
    this.can.admin = this.is.admin || this.apiService.moduleAccess.user_admin;

    this.getOrgUsers();
  }

  getOrgUsers() {
    this.isLoading = true;
    this.userSelected.set(null);
    this.userService.getUsersForOrg().then(
      users => {
        this.users.set(users.filter(u => (u.role !== 'admin' || this.showAdmin) && u.role !== 'contact').sort((a, b) => a.name > b.name ? -1 : 1).sort((a, b) => a.isActive ? -1 : 1));
        this.isLoading = false;
      }
    );
  }

  clickUserRow(user: User) {
    console.log(user);
    this.userSelected.set(user);
  }

  editUser() {
    this.userService.setIsEditing(true);
  }


  disableUserToggle() {

  }

  deleteUser(hasConfirmed = false) {
    if (hasConfirmed) {
      this.wantsToDeleteUser = false;
      this.apiService.toastSuccess('deleting...', '');
      this.userService.adminCommandPost('delete', { id: this.userSelected().id }).then(() => {
        this.apiService.toastSuccess('deleted.', '');
        this.getOrgUsers();
      });
    } else {
      this.wantsToDeleteUser = true;
    }
  }

  updateUser() {
    this.apiService.toastSuccess('updating...', '');
    this.userService.adminCommandPost('update', { id: this.userSelected().id, changes: this.dirtyData }).then(() => {
      this.apiService.toastSuccess('updated.', '');
      this.getOrgUsers();
    });
  }

  onDataChange(dirtyData: IDirtyData) {
    console.log('dirtyData', dirtyData);
    this.dirtyData = dirtyData;
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      console.log('USER UNSUBSCRIBE');
      this.userSubscription.unsubscribe();
    }
  }
}
